/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2019, Zumper
 * @description payloadReducer - a reducer that returns `action.payload`
 */

import { AnyAction } from 'redux-actions'

type PayloadReducer = <State, Action extends AnyAction>(
  state: State,
  action: Action
) => Action['payload']

export const payloadReducer: PayloadReducer = (state, action) => action.payload
